module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ep"
    }
  }, [_c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "ep"
  }, [_c('a', {
    staticClass: "page"
  })]), _vm._v(" "), _c('p', {
    staticClass: "ep",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("I think it’s a metaphysical concept")]), _vm._v(" "), _c('p', {
    staticClass: "ep",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("starting with Aristotle and flowering in St. Thomas")]), _vm._v(" "), _c('p', {
    staticClass: "ep",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("that God is pure act and that there is no potentia in Him.")]), _vm._v(" "), _c('p', {
    staticClass: "ep",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(". . . Almost everything else in the universe is in potentia,")]), _vm._v(" "), _c('p', {
    staticClass: "ep",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("it’s on its way to being pure act,")]), _vm._v(" "), _c('p', {
    staticClass: "ep",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("on its way to unity with God.")]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_vm._v("Robert Lax")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("Depending upon the reader, it is all either baffling or beatific.")]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_vm._v("American Library Association Booklist review of "), _c('i', [_vm._v("33 Poems")]), _vm._v(", the first Lax book issued by a major American publisher")])]), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "px"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e56026e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/McGregor0006.vue
// module id = 72
// module chunks = 0